// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"7553":"e919c1aa","8301":"ca4dcb09"}[chunkId] || chunkId) + "." + {"4793":"5337f531719f175c","7553":"4c2d6aa5dd9859d9","8301":"4d1b9f8dd8766c14","9504":"43d578d281d1cb27","9656":"7fc7472253c72150"}[chunkId] + ".js";
};